<template>
  <div class="success">
    <div class="success-header">
      <div class="logo"></div>
      <div class="text-center info">
        <h1>Спасибо за покупку и приятного просмотра!</h1>
        <p>
          Информация о заказе отправлена на вашу почту или введите его в
          терминале по выдаче билетов.
        </p>
      </div>
      <div class="contact" v-if="setting.supportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ setting.supportPhone }}</div>
      </div>
    </div>
    <div class="success-body">
      <div class="success-body-wrapper">
        <div
          class="success-session-wrapper"
          :style="{
            'background-image':
              'linear-gradient(to bottom, #000000b3 0%, #000000b3 100%), url(' +
              this.movie.MovieImageUrl +
              ')',
          }"
        >
          <div class="success-session-title" v-if="session.DateTime">
            {{ new Date(session.DateTime) | moment('dddd, D MMMM в H:mm') }}
          </div>
          <div class="success-session-footer">
            <div class="success-session-tags">
              <div class="tag" v-if="session.Format">
                {{ session.Format.Name }}
              </div>
              <div class="tag">{{ movie.Rate }}</div>
            </div>
            <div class="success-session-name">{{ session.MovieName }}</div>
          </div>
        </div>
        <div class="cart-wrapper">
          <div class="cart-wrapper-inner">
            <div class="cart-scrollable success-scrollable">
              <div class="theatre-wrapper">
                <div class="label">Площадка</div>
                <div class="name" v-if="session.Hall">
                  {{ theatre.NameFull }}, {{ session.Hall.Name }}
                </div>
                <div class="address">
                  {{ theatre.Address }}
                </div>
              </div>
              <div class="order-wrapper">
                <div class="label">Номер заказа билетов</div>
                <div class="order-number">{{ this.user.ticketOrderId }}</div>
              </div>
              <div class="qr-wrapper" v-if="user.ticketOrderId">
                <div class="desciption">
                  Приложите QR-код к считывающему устройству и получите входной билет
                </div>
                <div class="qr-code">
                  <qrcode
                    :value="user.ticketOrderId"
                    :options="{ size: 160 }"
                  ></qrcode>
                </div>
              </div>
              <div class="success-cart cart-items">
                <div class="cart-group cart-thicket" v-if="this.cart.tickets">
                  <div class="label">Билеты</div>
                  <div class="list">
                    <div
                      class="item"
                      v-for="(ticket, index) in this.cart.tickets"
                      :key="index"
                    >
                      <span class="position" v-if="!session.NoSeats"
                        >{{ ticket.row }} ряд {{ ticket.number }} место</span
                      >
                      <span class="position" v-else>{{ ticket.Name }}</span>
                      <span class="dots"></span>
                      <span class="price" v-if="ticket.price"
                        >{{ ticket.price }} {{ setting.currency }}</span
                      >
                      <span class="price" v-else>Бесплатно</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="order-wrapper" v-if="user.barOrderCode">
                <div class="label">Номер заказа бара</div>
                <div class="order-number">{{ this.user.barOrderCode }}</div>
              </div>
              <div class="qr-wrapper" v-if="user.barOrderCode">
                <div class="desciption">
                  Приложите QR-код к считывающему устройству и получите заказ в
                  баре
                </div>
                <div class="qr-code">
                  <qrcode
                    :value="user.barOrderCode"
                    :options="{ size: 160 }"
                  ></qrcode>
                </div>
              </div>
              <div class="success-cart cart-items" v-if="user.barOrderCode">
                <div class="cart-group cart-bar" v-if="this.cart.bar">
                  <div class="label">Бар</div>
                  <div class="list">
                    <div
                      class="item"
                      v-for="(item, index) in cart.bar"
                      :key="index"
                    >
                      <span class="position"
                        >{{ item.name }} {{ item.size }} ({{
                          item.count
                        }})</span
                      >
                      <span class="dots"></span>
                      <span class="price">{{
                        getTotalPrice(item.price, item.count)
                      }} {{ setting.currency }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cart-total">
            <div class="cart-total-label label">Итого:</div>
            <div class="cart-total-price">
              {{ cart.sum }} {{ setting.currency }}
              <span v-if="user.paymentWithBonuses"
                >(-{{
                  cart.spentBonuses.bar + cart.spentBonuses.tickets
                }}
                бонусов)</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="success-footer">
      <h4>С приложением - удобнее!</h4>
      <div class="info">Так же попробуйте наше мобильное приложение!</div>
      <div class="success-footer__link-items">
        <a
          href="https://itunes.apple.com/ru/app/%D0%BF%D1%80%D0%B5%D0%BC%D1%8C%D0%B5%D1%80-%D0%B7%D0%B0%D0%BB/id1251836829?mt=8"
          ><img src="/app-store.png" alt="Загрузить в AppStore"
        /></a>
        <a
          href="https://play.google.com/store/apps/details?id=ru.premierzal.apremier"
          ><img src="/play-market-2.png" alt="Загрузить в Play Market"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Success',

  computed: mapState([
    'cart',
    'session',
    'theatre',
    'movie',
    'user',
    'setting',
    'idToken'
  ]),

  created() {
    // eslint-disable-next-line no-undef
    dataLayer.push({ ecommerce: null });  // очистка уровня данных.
    // eslint-disable-next-line no-undef
    dataLayer.push({
      'ecommerce': {
        'currencyCode': 'RUB',
        'purchase': {
          'actionField': {
            'id': this.idToken,         // где transaction id это id транзакции.
            'affiliation': 'Online',
            'revenue': this.cart.sum           // где total это сумма покупки
          },
          'products': [
            ...this.cart.tickets.map(ticket => (
              {
                'id': ticket.id,              // где film_id это id фильма или товара.
                'name': ticket.name,          // где film_name это название фильма или товара.
                'price': ticket.price,      // где ticket_price это цена за билет или товар.
                'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                'quantity': '1'
              }
            )),
            ...this.cart.bar.map(barItem => (
              {
                'id': barItem.productId,              // где film_id это id фильма или товара.
                'name': barItem.name,          // где film_name это название фильма или товара.
                'price': barItem.price,      // где ticket_price это цена за билет или товар.
                'category': this.movie.Genres.join(', '),  // где category_name это название категории фильма.
                'brand': this.theatre.NameFull,           // где cinema это название кинотеатра.
                'variant': this.session.DateTime,      // где date-time это дата и время фильма.
                'quantity': barItem.count
              }
            ))
          ]
        },
        'event': 'gtm-ee-event',
        'gtm-ee-event-category': 'Enhanced Ecommerce',
        'gtm-ee-event-action': 'Purchase',
        'gtm-ee-event-non-interaction': 'False'
      }
    });
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    },

    getTotalPrice(price, count) {
      return price * count;
    },
  },
};
</script>

<style lang="scss">
h1.text-center {
  text-align: center;
}
%circle-btn {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  position: absolute;
  top: 20px;
  padding: 0;
  width: 42px;
  height: 42px;
  border: 2px solid #fff;
  border-radius: 100%;
  opacity: 0.3;
  cursor: pointer;
  justify-content: center;
  transition: 0.15s ease-in-out;
  &:hover {
    opacity: 1;
  }
}
.success {
  background-color: #24262c;
  color: #fff;
  height: 100%;
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  &-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    color: #fff;
    padding: 0 80px;
    height: 100px;
    border-bottom: 1px solid #fff3;
    overflow: hidden;
    box-sizing: border-box;
    .logo {
      display: none;
      width: 166px;
      height: 25px;
    }
    .info {
      text-align: center;
      padding-right: 20px;
      h1 {
        margin-bottom: 10px;
      }
      p {
        font-size: 75%;
      }
    }
    .timer {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      justify-content: space-between;
      width: 210px;
      white-space: normal;
      &-label {
        text-transform: uppercase;
        padding: 0 7px 0 0;
        font-size: 9px;
        line-height: 11px;
        letter-spacing: 0.06em;
        margin-bottom: 2px;
        padding: 0;
        letter-spacing: 1px;
        color: #fffc;
      }
      &-time {
        font-size: 17px;
        line-height: 21px;
        color: #fff;
        letter-spacing: 0.1em;
      }
    }
    .contact {
      display: none;
      &-label {
        text-transform: uppercase;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 1px;
        color: #fff;
        color: #fffc;
        margin-bottom: 2px;
      }
      &-number {
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
        letter-spacing: 0.5px;
        color: #fff;
      }
    }
    .button-back {
      @extend %circle-btn;
      left: 15px;
      .btn-icon {
        // width: 26px;
        // height: 26px;
        background-position: 50% 50%;
      }
    }
    .button-close {
      @extend %circle-btn;
      right: 15px;
      .btn-icon {
        // width: 26px;
        // height: 26px;
        background-position: 50% 50%;
      }
    }
  }
  &-body-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 6px 20px;
    .label {
      font-size: 15px;
      margin-bottom: 10px;
      text-transform: uppercase;
      line-height: 13px;
      letter-spacing: 0.077em;
      color: #0d76ff;
    }
  }
  &-body {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0;
  }
  &-session {
    &-wrapper {
      box-sizing: border-box;
      padding: 15px 15px 22px;
      height: 100%;
      min-height: 146px;
      color: #fff;
      background-color: #000;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: cover;
      border-radius: 10px 10px 0 0;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-content: center;
      display: flex;
    }
    &-title {
      font-size: 16px;
      line-height: 19px;
    }
    &-tags {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      .tag {
        margin: 3px 6px 0 0;
        padding: 3px 6px 2px;
        width: auto;
        background: #fff9;
        border-radius: 4px;
        font-size: 11px;
        line-height: 13px;
        color: #000000b3;
        box-sizing: border-box;
        display: block;
        font-weight: 500;
        text-align: left;
        cursor: default;
      }
    }
    &-name {
      margin: 8px 0 0;
      font-size: 20px;
      line-height: 24px;
    }
  }
  &-footer {
    display: flex;
    flex-direction: column;
    color: #ffffff;
    padding: 20px 60px 20px 15px;
    background: #0d76ff;
    border-radius: 10px;
    align-items: flex-start;
    h4 {
      margin-bottom: 20px;
    }
    .info {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 20px;
    }
    &__link-items {
      display: flex;
      flex-wrap: nowrap;
      a {
        display: block;
        width: 180px;
        & > img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
}

.cart {
  &-wrapper {
    background: #fff;
    padding-bottom: 55px;
    border-radius: 0 0 10px 10px;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    position: relative;
    overflow: hidden;
    &-inner {
      padding: 15px 15px 0;
      margin-top: 19px;
      flex: 1 1 auto;
      position: relative;
      &:before {
        position: absolute;
        content: '';
        right: 0;
        top: 0;
        left: 0;
        height: 15px;
        z-index: 2;
        transform: rotate(180deg);
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+84 */
        background: -moz-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* FF3.6-15 */
        background: -webkit-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
        /* IE6-9 */
      }
      &:after {
        position: absolute;
        content: '';
        right: 0;
        bottom: 0;
        left: 0;
        height: 15px;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+84 */
        background: -moz-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* FF3.6-15 */
        background: -webkit-linear-gradient(
          top,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 84%,
          rgba(255, 255, 255, 1) 100%
        );
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
        /* IE6-9 */
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 70%);
      width: 80px;
      border-radius: 50%;
      height: 80px;
      background-color: #0d76ff;
      -webkit-box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
      -moz-box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
      box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.35);
    }
    .order-wrapper {
      color: #000;
      margin-bottom: 15px;
      .order-number {
        font-size: 21px;
        font-weight: bolder;
      }
    }
    .qr-wrapper {
      color: #000;
      .description {
        text-align: center;
      }
      .qr-code {
        display: flex;
        width: 170px;
        height: 170px;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
  &-scrollable {
    padding: 0;
  }
  &-items {
    margin-bottom: 20px;
  }
  &-group {
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      color: #777;
      font-size: 14px;
      .position {
        padding-right: 5px;
      }
      .dots {
        height: 10px;
        border-bottom: 1px dotted #0000004d;
        flex: 1 0 15px;
      }
      .price {
        flex: 0 0 auto;
        padding-left: 8px;
      }
    }
  }
  &-total {
    margin: 26px 0 0;
    font-size: 22px;
    text-align: right;
    color: #000000;
    display: flex;
    justify-content: flex-end;
    padding: 0 30px;
    align-items: center;
    &-label.label {
      margin-bottom: 0;
      font-size: 18px;
      line-height: normal;
      margin-right: 10px;
    }
    &-price {
      font-size: 18px;
      line-height: normal;
    }
  }
}

@media (min-width: 768px) {
  .success {
    &-header {
      justify-content: space-between;
      .info {
        max-width: 450px;
      }
      .logo {
        display: block;
      }
      .contact {
        display: block;
      }
    }
    &-body {
      padding: 14px 32px 36px 68px;
      &-wrapper {
        padding: 0 25px 0 0;
        flex: 0 0 400px;
        margin: 0 auto;
      }
    }
    &-wrapper {
      flex: 0 0 335px;
      padding: 0 25px 0 0;
      height: 100%;
    }
    &-session {
      &-wrapper {
        padding: 15px 30px 22px;
        flex-basis: 225px;
        min-height: auto;
      }
      &-name {
        font-size: 15px;
        line-height: 18px;
      }
    }
    &-footer {
      align-items: center;
      border-radius: 0;
    }
  }
  .cart {
    &-wrapper {
      margin-bottom: 0;
      &-inner {
        padding: 0 15px 0 30px;
      }
    }
    &-total {
      padding: 0 30px;
    }
    &-scrollable {
      padding: 10px 10px 0 0;
      overflow-y: auto;
      max-height: 25vh;
      transform: translateZ(0);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      &.success-scrollable {
        max-height: none;
      }
    }
  }
}

@media (max-width: 768px) {
  .success {
    &-header {
      padding: 0 40px;
      height: 140px;
    }
  }
}
</style>
